import { lazy } from "react";
import componentFactory from "@/factories/component-factory.ts";
import type { Nullable } from "@/types";
import { type ChoiceWithPossibleIndicator, FilterType, type PropertyConfigCode } from "../../types";

const RadioImages = lazy(() => import("./radio-images.tsx"));
const Radios = lazy(() => import("./radios.tsx"));
const SingleSelectCheckboxes = lazy(() => import("./single-select-checkboxes.tsx"));

export type FilterProps = {
    choices: ChoiceWithPossibleIndicator[];
    configCode: Nullable<PropertyConfigCode>;
    onClick: (configCode: Nullable<PropertyConfigCode>, isPossible: boolean) => void;
};

const filters = {
    [FilterType.RadioImages]: RadioImages,
    [FilterType.Radio]: Radios,
    [FilterType.SingleSelectCheckboxes]: SingleSelectCheckboxes,
} as const;

export const Filter = componentFactory(filters);
